/* eslint-disable import/no-extraneous-dependencies */
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { FaChevronCircleRight } from '@react-icons/all-files/fa/FaChevronCircleRight';
import LazyImage from 'gatsby-core-theme/src/hooks/lazy-image';
import Button from 'gatsby-core-theme/src/components/atoms/button';
import { translate, imagePrettyUrl, prettyTracker } from 'gatsby-core-theme/src/helpers/getters';
import { Context } from '~context/TranslationsProvider';
import RegistrationSteps from '../../molecules/registration-steps';
import styles from './provider-tabs.module.scss';

/* eslint-disable react/jsx-wrap-multilines */

const ProviderTabs = ({ pageContext, provider, isStorybook = false }) => {
  const { translations } = useContext(Context) || {};
  const sport = pageContext?.page?.relation?.sport?.name;

  return (
    <div className={`${styles.providerContent}`}>
      <h4>
        <LazyImage
          src={imagePrettyUrl(provider?.rectangle_logo)}
          alt={provider?.name}
          width={70}
          height={35}
        />
        {`${translate(translations, 'watch_live_stream_at', 'Watch live stream')} ${translate(
          translations,
          'with_1',
          'at'
        )}: `}
      </h4>
      <h5>{`${translate(translations, 'quality', 'Quality')}:`}</h5>
      <p>{provider?.sports_data[sport]?.quality_content}</p>
      <h5>{`${translate(translations, 'selection', 'Provider')}:`}</h5>
      <p>{provider?.sports_data[sport]?.selection_content}</p>
      <h5>{`${translate(translations, 'price', 'Price')}:`}</h5>
      {provider?.sports_data[sport]?.price_content}
      <h5>{`${translate(translations, 'how_you_do_it', 'Here is how you do it')}:`}</h5>

      <div className={`${styles.steps}`}>
        <RegistrationSteps
          steps={provider}
          sport={pageContext?.page?.relation?.sport?.name}
          link={prettyTracker(provider, 'main', true)}
          context="provider-tabs"
          tncText={translate(translations, 'terms_and_conditions', 'Terms & conditions')}
          isStorybook={isStorybook}
          gtmClass="provider-tabs-registration-steps-gtm"
        />
      </div>

      <div className={styles.btnWrapper}>
        {provider.featured === 1 && (
          <Button
            to={provider?.path || '#'}
            isInternalLink
            primaryColor={false}
            invertedColors
            btnText={
              <>
                <FaChevronCircleRight />
                {translate(translations, 'read_review', 'Read review')}
              </>
            }
            gtmClass="provider-tab-gtm btn-cta"
          />
        )}
        <Button
          to={prettyTracker(provider, 'main', true)}
          isInternalLink={false}
          primaryColor
          targetBlank={false}
          className={sport}
          btnText={
            <>
              <FaChevronCircleRight />
              {`${translate(translations, 'go_to', 'Go to')} ${provider?.name}`}
            </>
          }
          gtmClass="provider-tab-gtm btn-cta"
        />
      </div>
    </div>
  );
};

ProviderTabs.propTypes = {
  pageContext: PropTypes.shape({
    page: PropTypes.shape({
      type: PropTypes.string,
      relation: PropTypes.shape({
        sport: PropTypes.shape({
          name: PropTypes.string,
        }),
      }),
    }).isRequired,
  }).isRequired,
  provider: PropTypes.shape({
    rectangle_logo: PropTypes.string,
    name: PropTypes.string,
    featured: PropTypes.bool,
    path: PropTypes.string,
    sports_data: PropTypes.shape({
      soccer: PropTypes.shape({
        quality_content: PropTypes.string,
        selection_content: PropTypes.string,
        price_content: PropTypes.string,
      }),
      tennis: PropTypes.shape({
        quality_content: PropTypes.string,
        selection_content: PropTypes.string,
        price_content: PropTypes.string,
      }),
      handball: PropTypes.shape({
        quality_content: PropTypes.string,
        selection_content: PropTypes.string,
        price_content: PropTypes.string,
      }),
    }),
  }),
  isStorybook: PropTypes.bool,
};

export default ProviderTabs;
